import { useCallback } from 'react';

import { DialogContent, DialogTitle, Box, Button, DialogActions, Typography, IconButton, SxProps } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { Close } from '@mui/icons-material';

import { closeDialog } from '../../redux/reducer/dialogSlice';
import { RootState } from '../../redux/store';
import { Theme } from '@emotion/react';
import { useLocation } from 'react-router-dom';

type GlobalDialogContentProps = {
    dialogBody: React.ReactNode;
    dialogFooter?: React.ReactNode;
    isShowDialogFooter?: boolean;
    dialogContentStyles?: SxProps<Theme>;
};

const GlobalDialogContent = ({ dialogBody, dialogFooter, isShowDialogFooter = true, dialogContentStyles = {} }: GlobalDialogContentProps) => {
    const dispatch = useDispatch();
    const { title } = useSelector((state: RootState) => state.dialog);
    const projectLocation = useSelector((state: RootState) => state.projectLocation.CreateProjectlocation);

    const location = useLocation();
    const handleClose = useCallback(() => { dispatch(closeDialog()); }, [dispatch]);

    return (
        <Box >
            <DialogTitle sx={{ fontWeight: 'bold', fontSize: '24px', color: 'grey.800', borderBottom: '1px solid #e0e0e0', backgroundColor: '#f5f5f5', padding: '10px', position: "sticky", zIndex: "99", top: "0" }} >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h4">{title ? title : projectLocation?.address || 'Choose Location'}</Typography> <IconButton size="small" onClick={handleClose}> <Close sx={{ fontSize: '20px', color: 'grey.600' }} /> </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ overflow: 'auto', maxHeight: "40rem", padding: "16px", paddingTop: "15px !important", ...dialogContentStyles }}>
                {dialogBody}
            </DialogContent>
            {(isShowDialogFooter && location.pathname !== '/admin/master/workflow') && (
                <DialogActions sx={{ px: 2, py: 1, bottom: "0", left: "0", right: "0", borderTop: '1px solid #e0e0e0', position: "sticky", zIndex: "99" }}>
                    <Button variant="outlined" color='error' onClick={handleClose}>Close</Button>
                    {dialogFooter}
                </DialogActions>
            )}
        </Box>
    )
}
export default GlobalDialogContent;